import type { ReactNode } from 'react'
import { Chip } from './Chip'
import type { ChipTone } from './tokens'

export const Badge = ({ tone = 'neutral', children, title }: { tone?: ChipTone; children: ReactNode; title?: string }) => (
  <Chip tone={tone} {...(title === undefined ? {} : { title })}>
    {children}
  </Chip>
)
